export function extractCityAndState(addressComponents) {
  let city = '';
  let state = '';

  addressComponents.forEach(component => {
    if (component.types.includes('administrative_area_level_2')) {
      city = component.long_name;
    }
    if (component.types.includes('administrative_area_level_1')) {
      state = component.short_name;
    }
  });

  return { city, state };
}
